import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

// Components
import ErrorBoundary from "./ErrorBoundary";

// Constants
import { ALLOWED_JSD_WIDGET_VWAG } from "../../constants/userConstants";

// Core Components
import ScrollToTopButton from "../core/ScrollToTopButton";
import MDCHelpCenterButton from "../core/MDCHelpCenterButton";

class PrivateRoute extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      widthJSMWidget: 0,
    };
  }
  componentDidUpdate() {
    if (this.props.authentication?.user) {
      const jsdWidgetIframe = document.querySelector('[id^="jsd-widget"]');
      if (jsdWidgetIframe) {
        const iframe = document.querySelector('iframe[id^="jsd-widget"]');
        if (
          iframe &&
          this.props.authentication?.user?.pGroupId === ALLOWED_JSD_WIDGET_VWAG
        ) {
          iframe.style.setProperty("display", "block", "important");

          if (iframe) {
            const iframeDoc = iframe.contentWindow.document;

            const subclassElement = iframeDoc.querySelector("#help-button");

            subclassElement && subclassElement.setAttribute("tabIndex", "0");

            const jsmButtonLoaded = iframeDoc?.querySelector(
              ".help-button-contents"
            );

            jsmButtonLoaded && jsmButtonLoaded.setAttribute("tabIndex", "0");

            const iframeRootElement = iframeDoc.querySelector("#react-root");

            const iframeRootElementWidth =
              iframeRootElement.children && iframeRootElement.offsetWidth;

            const nonEmptyChildren = Array.from(
              iframeRootElement.children
            ).filter((child) => {
              // Check if it has text or contains other elements
              return (
                child.textContent.trim().length > 0 || child.children.length > 0
              );
            });

            if (
              jsmButtonLoaded &&
              nonEmptyChildren.length > 0 &&
              this.state.widthJSMWidget !== iframeRootElementWidth
            ) {
              this.setState({
                widthJSMWidget: iframeRootElementWidth, // In Pixels
              });
            }
          }
        } else {
          if (iframe) {
            iframe.remove(); // Removes the iframe from the DOM
          }
        }
      }
    } else {
      const removeIframe = document.querySelector('[id^="jsd-widget"]');
      if (removeIframe) {
        removeIframe.style.setProperty("display", "none", "important");
      }
    }
  }

  isAuthorised = (roles) => {
    let allowed = false;
    roles.map((role) => {
      if (!allowed) {
        allowed = this.props?.authentication?.user?.roles?.includes(role);
      }
    });
    return allowed;
  };

  render() {
    const { component: Component, roles, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          const currentUser = this.props?.authentication?.user;

          if (!currentUser) {
            if (this.props?.authentication?.redirectUrl) {
              return (
                <Redirect
                  to={{
                    pathname: "/logout",
                    state: {
                      redirectUrl: this.props?.authentication?.redirectUrl,
                    },
                  }}
                />
              );
            } else {
              // not logged in so redirect to login page with the return url
              return (
                <Redirect
                  to={{ pathname: "/login", state: { from: props.location } }}
                />
              );
            }
          }

          // check if route is restricted by role
          if (
            roles &&
            !this.isAuthorised(roles) &&
            !this.props?.authentication.redirectUrl
          ) {
            // role not authorised so redirect to home page
            return <Redirect to={{ pathname: "/" }} />;
          }

          const isVWGGroup =
            this.props.authentication?.user?.pGroupId ===
            ALLOWED_JSD_WIDGET_VWAG;

          // authorised so return component
          return (
            <ErrorBoundary>
              <Component {...props} />
              {/* show scroll to top button in all pages */}
              <ScrollToTopButton />
              {/* Enable help center button in all pages groups */}
              <MDCHelpCenterButton
                loadingWidget={isVWGGroup}
                loadedWidgetWith={
                  isVWGGroup
                    ? this.state.widthJSMWidget > 0 &&
                      this.state.widthJSMWidget / 16
                    : 0
                }
              />
            </ErrorBoundary>
          );
        }}
      />
    );
  }
}

function mapState(state) {
  const { authentication } = state;
  return { authentication };
}

export default connect(mapState)(PrivateRoute);
